import { createContext, FC, PropsWithChildren, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { createContextualCan, useAbility } from '@casl/react'
import { getUser } from 'redux/store/user/getters'
import { ability, defineAbility, BankAccountAbility } from '../Abilities'
import { AnyAbility } from '@casl/ability'

export const BankAccountAbilityContext =
  createContext<BankAccountAbility>(ability)

const BankAccountAbilityProvider: FC<PropsWithChildren> = ({ children }) => {
  const user = useSelector(getUser)

  const ability = useMemo(() => defineAbility(user), [user])

  return (
    <BankAccountAbilityContext.Provider value={ability}>
      {children}
    </BankAccountAbilityContext.Provider>
  )
}

export const useBankAccountAbility = () =>
  useAbility<BankAccountAbility>(BankAccountAbilityContext)

export const Can = createContextualCan<AnyAbility>(
  BankAccountAbilityContext.Consumer
)

export default BankAccountAbilityProvider
